
export default {
  // Location and Duration
  locationSelection: "Location Selection",
  campaignDuration: "Campaign Duration",
  numberOfScreens: "Number of Screens",
  days: "Days",
  day: "Day",
  devices: "Devices",
  duration: "Duration",
  total: "Total",
  selectAllIn: "Select All in",
  toggleAll: "Toggle All",
  // Region names
  allRegions: "All Regions",
  riyadh: "Riyadh",
  jeddah: "Jeddah", 
  easternProvince: "Eastern Province",
  medina: "Medina",
  alKharj: "Al Kharj",
  dawadmi: "Dawadmi",
  tabuk: "Tabuk",
  hail: "Hail",
  hafarAlBatin: "Hafar Al Batin",
  majmaa: "Majmaa",
  qassim: "Qassim",
  sakaka: "Sakaka",
  arar: "Arar",
  alQurayyat: "Al Qurayyat",
  alJubail: "Al Jubail",
  yanbu: "Yanbu",
  khamisMushait: "Khamis Mushait",
  sabia: "Sabia",
  abha: "Abha",
  jizan: "Jizan",
  najran: "Najran",
  muhayil: "Muhayil",
  alBahah: "Al Bahah",
  
  // Device map filters
  mediaOwner: "Media Owner",
  mediaType: "Media Type",
  all: "All",
  indoor: "Indoor", 
  outdoor: "Outdoor",
  
  // Map popup translations
  screens: "faces",
  viewReferenceImage: "View Reference Image",
  locationReferenceImage: "Location Reference Image",
  outdoorLedDisplay: "Outdoor LED display platinum series:",
  pixelSizes: "pixel sizes 10mm",
  highBrightness: "High Brightness: SMD 10000nits",
  cost: "Cost",
  locationType: "Location Type",
  availableFaces: "Available Faces",
  screenSize: "Screen Size",
  gender: "Gender",
  ageRange: "Age Range",
  orientation: "Orientation",
  segment: "Segment",
  schoolType: "School Type",
  educationLevel: "Education Level",
  students: "Students",
  description: "Description",
  removeLocation: "Remove Location",
  bookScreens: "Book Screens",
  deselectLocation: "Deselect Location",
  selectLocation: "Select Location",
  screenSelection: "Face Selection",
  screensToBook: "Faces to Book",
  screen: "face",
  selectExactScreens: "Select exactly the number of faces you need",
  
  // Price and dynamic content
  sarPerScreenPerDay: "SAR per screen per day",
  sarPerFacePerDay: "SAR per face per day",
  price: "Price",
  
  // Location types that might appear in data
  digitalBridgeScreen: "Digital Bridge Screen",
  outdoorBillboard: "Outdoor Billboard",
  
  // Common values that might appear
  male: "Male",
  female: "Female",
  mixed: "Mixed",
  landscape: "Landscape",
  portrait: "Portrait",
  
  // Date selection mode
  dateRange: "Date Range",
  specificDates: "Specific Dates",
  selectSpecificDates: "Select specific dates for your campaign",
  datesSelected: "dates selected",
  clearAll: "Clear All",
  selectAllMonth: "Select All"
} as const;
